import React, { useEffect, useRef, useState } from "react";
import { dateFormator, mapTableRows } from "../../../../utils";
import {
  Button,
  FormFieldSet,
  Modal,
  TableAdv,
  SmartTooltip,
  Backdrop,
  LogoLoader,
  showToast,
  DualIcon,
} from "../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import { getMonsterApplicantsDataStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import ApplicantsDetailsDrawer from "../../Applicants/Applicant/Modal/ApplicantsDetailsDrawer";
import {
  CreateListModal,
  MailMergeModal,
} from "../Modals/MonsterModals/MonsterModals";
import { monsterSearchOptions } from "../../../../assets/data/enumData";
import {
  getAllIntegrationAccess,
  getAllIntegrations,
} from "../../../../redux/slices/setting/settingApi";
import { fetchBulkResumesDataStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { setMonsterAccessidStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import AddNoteModal from "../../ConfirmedStart/Confirmed/modals/AddNoteModal";
import { formatWords2 } from "../../../../utils/stringUtils";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { fetchAllNotes, addVisitHistoryApi, fetchVisitHistorysApi } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import AiCallModel from "../Modals/AiCallModel";

const getJobBoardsName = {
  1: "Internal DB",
  2: "Career Builder",
  3: "Monster",
};

const IntegratedMonster = ({
  monsterQuery,
  onMonsterQueryChange,
  showResumeButton,
  keywords,
  source,
}) => {
  const [migrateModal, setMigrateModal] = useState(false);
  const { monster } = useSelector((state) => state.internalDbES);
  const {
    total,
    tableResponse = [],
    fullResponse: monsterFullResponse,
    existingCandidates: existingCandidatesM = [],
  } = monster;
  console.log("existingCandidatesM", existingCandidatesM);
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const { loginUserUiid } = useLoginUser();
  const [createListModal, setCreateListModal] = useState(false);
  const [mailMergeModalOpen, setMailMergeModalOpen] = useState(false);
  const [selectMigratedProfiles, setSelectedMigratedProfiles] = useState([]);
  const [defaultExistingCandidates, setDefaultExistingCandidates] = useState(
    [],
  );
  const [selectedApplicantId, setSelectedApplicantId] = useState(null);
  // const candidate = (existingCandidatesM || []).find((c) =>
  //   (c?.resumeIds || []).some((r) => (r?.id) === selectedApplicantId)
  // );
  // const candidateId = candidate?.uiid || candidate?.applicantId;
  const candidates = existingCandidatesM ?? [];
  const candidate = candidates.find((c) =>
    (c?.resumeIds ?? []).some(
      (r) => String(r?.id) === String(selectedApplicantId),
    ),
  );
  const candidateId = candidate?.uiid ?? candidate?.applicantId ?? null;
  const [monsterSort, setMonsterSort] = useState(monsterSearchOptions[0].value);

  const [noteModal, setNotesModal] = useState(false);
  // const noResumeCandidate = (tableResponse || []).find(
  //   (c) => c?.applicantId === selectedApplicantId
  // );
  // const noResApplicantId =
  //   noResumeCandidate?.uiid || noResumeCandidate?.resumeId;
  const tableResponseRows = tableResponse ?? [];
  const noResumeCandidate = tableResponseRows.find(
    (c) => String(c?.applicantId) === String(selectedApplicantId),
  );
  const noResApplicantId =
    noResumeCandidate?.uiid ?? noResumeCandidate?.resumeId ?? null;
  // console.log(tableResponse)
  // console.log(monsterFullResponse)
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.internalDbES.loading);
  const firstRender = useRef(true);
  const { accessData } = useSelector((state) => state.internalDbES);
  const [mailMergeCandidates, setMailMergeCandidates] = useState([]);
  const [selected, setSelected] = useState([]);
  const [hoveredNotes, setHoveredNotes] = useState([]);
  const [hoveredVisitHistorys, setHoveredVisitHistorys] = useState([]);
  const [tableRenderKey, setTableRenderKey] = useState(0);
  const [isAiCallModalOpen, setIsAiCallModalOpen] = useState(false);
  const [hasAiCallAccess, setHasAiCallAccess] = useState(false);

  const handleMigratedProfiles = (currentValueArray) => {
    // check if our single option '1' is actually selected
    const isSelected =
      Array.isArray(currentValueArray) && currentValueArray.includes("1");

    if (!isSelected) {
      // deselected: clear defaults
      setDefaultExistingCandidates([]);
      setMailMergeCandidates([]);
      return;
    }

    const existingResumeIdSet = new Set(
      (existingCandidatesM || [])
        .flatMap((candidate) => candidate?.resumeIds || [])
        .filter(Boolean)
        .map((r) => String(r?.id)),
    );

    if (existingResumeIdSet.size === 0) {
      setDefaultExistingCandidates([]);

      return;
    }

    const candidates = (tableResponse || [])
      .filter((doc) => {
        return doc?.resumeId && existingResumeIdSet.has(String(doc.resumeId));
      })
      .map((doc) => doc.applicantId);

    setDefaultExistingCandidates(candidates);
    const candidatesData = (tableResponse || []).filter((doc) => {
      return doc?.resumeId && existingResumeIdSet.has(String(doc.resumeId));
    });
    setMailMergeCandidates(candidatesData);
  };

  const mailSet = new Set(mailMergeCandidates.map((m) => m.resumeId));
  const filtered = (existingCandidatesM || [])
    .filter((c) => c.resumeIds?.some((r) => mailSet.has(r.id)))
    .map(({ firstName, lastName, jobTitle, uiid, email, exp, salaryInfo }) => ({
      applicantId: uiid,
      firstName,
      lastName,
      jobTitle,
      uiid,
      email: email?.primary?.email ?? email?.primary ?? "",
      experience: `${exp?.year ?? "-"} years ${exp?.mon ?? "-"} months`,
      payrate: salaryInfo?.payRate?.currency ?? "",
    }));
  // console.log(existingCandidatesM)
  // console.log(filtered)
  const filteredApplicantData = existingCandidatesM?.find((c) =>
    c?.resumeIds?.some((r) => String(r?.id) === String(selectedApplicantId)),
  );
  const sendData = {
    addedBy: { uiid: loginUserUiid },
    candidateId: { uiid: filteredApplicantData?.uiid },
  };

  const matchedMigratedCandidates = selected.every((id) =>
    tableResponse.some(
      (r) =>
        r.applicantId === id &&
        (existingCandidatesM || []).some((c) =>
          c?.resumeIds?.some((x) => x.id === r.resumeId),
        ),
    ),
  );
  const showMailMergeForMigrated =
    selected.length > 0 && matchedMigratedCandidates;

  // Pagination Helpers
  const { page, limit, setPage, handleLimitChange } = usePagination(
    monsterQuery?.payload?.lim,
    (newPage, newLimit) => {},
    monsterQuery?.payload?.page,
  );

  const handleSelectionChange = (selected) => {
    ////////for checkbox
    const migratedApplicantIds = (tableResponse || [])
      .filter((r) =>
        (existingCandidatesM || []).some((c) =>
          c?.resumeIds?.some((x) => x.id === r.resumeId),
        ),
      )
      .map((r) => r.applicantId);
    const allSelectedAreMigrated = selected.every((id) =>
      tableResponse.some(
        (r) =>
          r.applicantId === id &&
          (existingCandidatesM || []).some((c) =>
            c?.resumeIds?.some((x) => x.id === r.resumeId),
          ),
      ),
    );
    setSelectedMigratedProfiles(
      allSelectedAreMigrated && selected.length === migratedApplicantIds.length
        ? ["1"]
        : [],
    );
    //////for checkbox
    setSelected(selected);
    setDefaultExistingCandidates(selected);
    const updatedCandidates = (tableResponse || [])
      .filter((doc) => selected.includes(doc?.applicantId))
      .filter(Boolean);
    setMailMergeCandidates(updatedCandidates);
  };

  const handleLimitChangeWithReset = (newLimit) => {
    setSelected([]);
    setDefaultExistingCandidates([]);
    setMailMergeCandidates([]);
    setSelectedMigratedProfiles([]);
    handleLimitChange(newLimit);
  };

  const handlePageChange = (newPage) => {
    setSelected([]);
    setDefaultExistingCandidates([]);
    setMailMergeCandidates([]);
    setSelectedMigratedProfiles([]);
    setPage(newPage);
  };

  const handleDelete = (uiid) => {
    //  console.log(filtered)
    // 1️⃣ get resumeId from existingCandidatesCB using uiid
    const resumeId = (existingCandidatesM || []).find((c) => c.uiid == uiid)
      ?.resumeIds?.[0]?.id;

    if (!resumeId) return;

    // 2️⃣ get applicantId from tableResponse using resumeId
    const applicantId = (tableResponse || []).find(
      (row) => row.resumeId == resumeId,
    )?.applicantId;

    if (!applicantId) return;
    // 4️⃣ remove from mail merge list
    setDefaultExistingCandidates((prev) =>
      prev.filter((id) => String(id) != String(applicantId)),
    );
    setMailMergeCandidates((prev) =>
      prev.filter(
        (candidate) => String(candidate?.applicantId) != String(applicantId),
      ),
    );
    setSelectedMigratedProfiles([]); //for checkbox
  };

  const getHoveredNotes = async (notes) => {
    setHoveredNotes([]);
    try {
      const res = await fetchAllNotes({
        coll: "Note",
        pg: 1,
        lim: 2,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: notes } },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
      });

      if (res?.data) {
        setHoveredNotes(res.data.data || []);
      } else {
        setHoveredNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
    }
  };

  const getHoveredVisitHistorys = async (applicantId) => {
    setHoveredVisitHistorys([]);
    try {
      if (!applicantId) return;
      const res = await fetchVisitHistorysApi({
        coll: "VisitHistory",
        fil: {
          candidateId: { type: "NONE", value: applicantId },
        },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
        limit: 5,
      });

      if (res?.data) {
        setHoveredVisitHistorys(res.data.data || []);
      } else {
        setHoveredVisitHistorys([]);
      }
    } catch (error) {
      console.error("Error fetching visit history:", error);
    }
  };

  const handleVisitHistory = async (candidateId) => {
    try {
      if (!candidateId) return;
      await addVisitHistoryApi({
        coll: "VisitHistory",
        payload: {
          candidateId: candidateId,
          addedBy: loginUserUiid,
        },
      });
    } catch (error) {
      console.error("Error logging visit history:", error);
    }
  };


  const columns = [
    // {
    //   key: "actions",
    //   label: "",
    //   columnMenu: false,
    //   render: (row) => (
    //     <div className="flex items-center">
    //       {existingCandidatesM?.find((c) =>
    //         (c?.resumeIds || []).some((r) => r?.id === row?.resumeId)
    //       )?.notes?.length > 0 && (
    //           <div
    //             onMouseEnter={() => {
    //               const isMatched = existingCandidatesM?.find((c) =>
    //                 (c?.resumeIds || []).some(
    //                   (r) => r?.id === row?.resumeId
    //                 )
    //               );
    //               if (!isMatched) return;
    //               const uiids = isMatched?.notes
    //                 .filter((n) => n && typeof n === "object" && n?.uiid)
    //                 .map((n) => n.uiid);

    //               const others = isMatched?.notes.filter(
    //                 (n) => !(n && typeof n === "object" && n?.uiid)
    //               );
    //               const merged = [...uiids, ...others]
    //               getHoveredNotes(merged)
    //             }}
    //             onMouseLeave={() => setHoveredNotes([])}
    //           >
    //             <SmartTooltip noicon description={
    //               Array.isArray(hoveredNotes) && hoveredNotes?.length > 0 ? (
    //                 <div className="flex flex-col gap-2">
    //                   {hoveredNotes?.map((hoveredNote, i) => (
    //                     <p key={i}>"{hoveredNote?.note || ""}" by {formatWords2(hoveredNote?.addedBy?.firstName) || ""} on {dateFormator(convertFromUTC(hoveredNote?.addedOn), "datetime-ampm") || ""}</p>
    //                   ))}
    //                 </div>
    //               ) : (
    //                 "Add note"
    //               )}>
    //               {existingCandidatesM?.find((c) =>
    //                 (c?.resumeIds || []).some((r) => r?.id === row?.resumeId)
    //               )?.notes?.length > 0 &&
    //                 <DualIcon
    //                   size="sm"
    //                   badgeIconColor={
    //                     existingCandidatesM?.find((c) =>
    //                       (c?.resumeIds || []).some((r) => r?.id === row?.resumeId)
    //                     )?.notes?.length > 0
    //                       ? "bg-success"
    //                       : "bg-dark"
    //                   }
    //                   onClick={() => {
    //                     const isMatched = existingCandidatesM?.find((c) =>
    //                       c?.resumeIds?.some((r) => r?.id === row?.resumeId)
    //                     );
    //                     if (isMatched) {
    //                       setSelectedApplicantId(row?.resumeId);
    //                       setNotesModal(true);
    //                     }
    //                   }}
    //                 />
    //               }
    //             </SmartTooltip>
    //           </div>
    //         )}
    //       {existingCandidatesM?.find((c) =>
    //         c?.resumeIds?.some((r) => r?.id === row?.resumeId)
    //       ) && (
    //           <SmartTooltip
    //             description={(() => {
    //               const migratedCandidate = existingCandidatesM?.find((c) =>
    //                 (c?.resumeIds || []).some((r) => r?.id === row?.resumeId)
    //               );

    //               return migratedCandidate
    //                 ? `Migrated by ${formatWords2(migratedCandidate?.addedBy?.firstName ?? "-")
    //                 } on ${dateFormator(migratedCandidate?.addedOn ?? "-")}`
    //                 : "Migrated";
    //             })()}
    //             noicon
    //           >
    //             <Button
    //               type="icon"
    //               size="sm"
    //               variant="text"
    //               icon="save"
    //               color="black"
    //             />
    //           </SmartTooltip>
    //         )}
    //       <Button
    //         color="black"
    //         type="icon"
    //         variant="text"
    //         icon={"visibility"}
    //         onClick={() => {
    //           setSelectedApplicantId(row?.resumeId);
    //           //console.log(row)
    //           setDetailsDrawer(true);
    //         }}
    //         size="sm"
    //       />
    //       {(row.id === 1 || row.id === 5) && (
    //         <Button
    //           color="black"
    //           type="icon"
    //           variant="text"
    //           size="sm"
    //           icon={"apk_install"}
    //         />
    //       )}
    //     </div>
    //   ),
    // },
    {
      key: "actions",
      label: "",
      columnMenu: false,
      render: (row) => {
        const matchedCandidate = (existingCandidatesM ?? []).find((c) =>
          (c?.resumeIds ?? []).some(
            (r) => String(r?.id) === String(row?.resumeId),
          ),
        );
        const notes = Array.isArray(matchedCandidate?.notes)
          ? matchedCandidate.notes
          : [];
        const hasNotes = notes.length > 0;
        return (
          <div className="flex items-center">
            {hasNotes && (
              <div
                onMouseEnter={() => {
                  const uiids = notes
                    .filter((n) => n && typeof n === "object" && n?.uiid)
                    .map((n) => n.uiid);

                  const others = notes.filter(
                    (n) => !(n && typeof n === "object" && n?.uiid),
                  );
                  getHoveredNotes([...uiids, ...others]);
                }}
                onMouseLeave={() => setHoveredNotes([])}
              >
                <SmartTooltip
                  noicon
                  description={
                    hoveredNotes?.length > 0 ? (
                      <div className="flex flex-col gap-2">
                        {hoveredNotes.map((note, i) => (
                          <p key={i}>
                            "{note?.note || ""}" by{" "}
                            {formatWords2(note?.addedBy?.firstName) || ""} on{" "}
                            {dateFormator(
                              convertFromUTC(note?.addedOn),
                              "datetime-ampm",
                            ) || ""}
                          </p>
                        ))}
                      </div>
                    ) : (
                      "Add note"
                    )
                  }
                >
                  <DualIcon
                    size="sm"
                    badgeIconColor={hasNotes ? "bg-success" : "bg-dark"}
                    onClick={() => {
                      setSelectedApplicantId(row?.resumeId);
                      setNotesModal(true);
                    }}
                  />
                </SmartTooltip>
              </div>
            )}
            {matchedCandidate && (
              <SmartTooltip
                noicon
                description={`Migrated by ${formatWords2(
                  matchedCandidate?.addedBy?.firstName ?? "-",
                )} on ${dateFormator(matchedCandidate?.addedOn ?? "-")}`}
              >
                <Button
                  type="icon"
                  size="sm"
                  variant="text"
                  icon="save"
                  color="black"
                />
              </SmartTooltip>
            )}
            <div
              onMouseEnter={() =>
                getHoveredVisitHistorys(matchedCandidate?.uiid)
              }
              onMouseLeave={() => setHoveredVisitHistorys([])}
            >
              <SmartTooltip
                noicon
                description={
                  Array.isArray(hoveredVisitHistorys) &&
                  hoveredVisitHistorys?.length > 0 ? (
                    <div className="flex flex-col gap-2">
                      {hoveredVisitHistorys.map((hoveredVisitHistory, i) => (
                        <p key={i}>
                          last visited by{" "}
                          {formatWords2(
                            hoveredVisitHistory?.addedBy?.firstName,
                          ) || ""}{" "}
                          on{" "}
                          {dateFormator(
                            convertFromUTC(hoveredVisitHistory?.addedOn),
                            "datetime-ampm",
                          ) || ""}
                        </p>
                      ))}
                    </div>
                  ) : (
                    "View Details"
                  )
                }
              >
                <Button
                  color="black"
                  type="icon"
                  variant="text"
                  icon="visibility"
                  size="sm"
                  onClick={() => {
                    handleVisitHistory(matchedCandidate?.uiid);
                    setSelectedApplicantId(row?.resumeId);
                    setDetailsDrawer(true);
                  }}
                />
              </SmartTooltip>
            </div>

            {/* {(row?.id === 1 || row?.id === 5) && (
              <Button
                color="black"
                type="icon"
                variant="text"
                size="sm"
                icon="apk_install"
              />
            )} */}
          </div>
        );
      },
    },
    // {
    //   key: "cId",
    //   label: "ID",
    //   columnMenu: false,
    //   //   width: "w-[100px]",
    // },
    // {
    //   key: "applicantId",
    //   label: "ID",
    //   columnMenu: false,
    //   //   width: "w-[100px]",
    // },
    {
      key: "name",
      label: "Name",
      columnMenu: false,
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "location",
      label: "Location",
      columnMenu: false,
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "jobTitle",
      label: "Job Title",
      columnMenu: false,
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "relocation",
      label: "Relocation",
      columnMenu: false,
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "highestEducation",
      label: "Highest Education",
      columnMenu: false,
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "jobType",
      label: "Job Type",
      columnMenu: false,
      width: "min-w-[100px]! max-w-[200px]!",
    },
    {
      key: "experience",
      label: "Experience",
      columnMenu: false,
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "source",
      label: "Source",
      columnMenu: false,
      width: "min-w-[100px]! max-w-[150px]!",
    },
    {
      key: "lastUpdate",
      label: "Last Update",
      columnMenu: false,
      width: "min-w-[100px]! max-w-[150px]!",
    },
  ];

  const rows = Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    cId: 21542,
    name: "Shaun Marsh",
    // email: "marsh222@gmail.com",
    // contact: "+1(986)5487562",
    jobTitle: "IT Program Manager",
    experience: "3 years",
    // workAuth: "USA",
    location: "NC, Durham",
    source: "Naukri",
    // currentCtc: "$ 3,00,000",
    // noticePeriod: "1 Month",
    // createdBy: "Thomas Clark",
    // lastActive: "Fri,10 Jul 2025, 20:52 (6 days ago)",
  }));
  // console.log(tableResponse)
  const integratedMRows = Array.from(
    { length: tableResponse?.length || 0 },
    (_, i) => ({
      id: tableResponse[i]?.applicantId,
      // cId: tableResponse[i]?.applicantId,
      name: formatWords2(tableResponse[i]?.name ?? "N/A"),
      location:
        tableResponse[i]?.location
          ?.split("-")
          ?.slice(1)
          ?.reverse()
          ?.join("-") ?? "N/A",
      // jobTitle: tableResponse[i]?.jobTitle ?? "N/A",
      jobTitle: formatWords2(tableResponse[i]?.experienceJobTitle ?? "N/A"),
      relocation: tableResponse[i]?.relocation ?? "N/A",
      highestEducation: tableResponse[i]?.highestEducation ?? "N/A",
      jobType: tableResponse[i]?.jobType ?? "N/A",
      experience: tableResponse[i]?.experience ?? "N/A",
      source: tableResponse[i]?.source,
      lastUpdate: tableResponse[i]?.lastUpdate ?? "N/A",
      resumeId: tableResponse[i]?.resumeId,
    }),
  );

  const mappedRows = mapTableRows(integratedMRows, columns);

  const handleMPagination = () => {
    const updatedQuery = {
      ...monsterQuery,
      payload: {
        ...monsterQuery?.payload,
        query: {
          ...monsterQuery?.payload?.query,
          ...(monsterSort ? { sort: monsterSort } : {}),
        },
        page: page,
        lim: limit,
      },
    };

    dispatch(
      getMonsterApplicantsDataStart({
        ...updatedQuery,
        onSuccess: () => {
          onMonsterQueryChange(updatedQuery);
        },
      }),
    );
  };

  // Pagination Use effect
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    handleMPagination();
  }, [page, limit, monsterSort]);

  // const noResumeCandidates = (tableResponse || []).filter(row =>
  //   !(existingCandidatesM || []).some(c =>
  //     (c?.resumeIds || []).some(r => r?.id === row?.resumeId)
  //   )
  // );

  const noResumeCandidates = (tableResponse || []).filter(
    (item) =>
      !(existingCandidatesM || []).find((ex) =>
        (ex?.resumeIds || []).some((r) => r?.id === item.resumeId),
      ),
  );

  const fetchSubmissions = async () => {
    // console.log(noResumeCandidates);
    const formattedCandidates = (noResumeCandidates || [])
      .slice(0, 10)
      .map((data) => ({
        resumeId: data?.resumeId,
        resumeBoardId: 1,
        firstName: data?.name?.split(" ")[0] ?? "",
        middleName: "",
        lastName: data?.name?.split(" ").slice(1).join(" ") ?? "",
        addedBy: loginUserUiid,
        jobTitle: data?.jobTitle || "",
        workAuth: `${data?.workAuthType || ""} ${data?.workAuthCountry || ""}`,
        workHistory: [
          {
            companyName: data?.experienceCompany || "",
            jobDetails: {
              title: data?.experienceJobTitle || "",
            },
          },
        ],
        militaryExp: {},
        educationDetails: [
          {
            degree: data?.highestEducation || "",
          },
        ],
        orgName: "tektree llc",
      }));

    try {
      const params = {
        coll: "IntegrationAccess",
        fil: {
          userId: {
            type: "FIND_INTIGRATION_ACCESS",
            value: loginUserUiid,
            category: 3,
            categoryType: 1,
            status: 1,
          },
        },
        useAggregate: true,
      };
      const response = await getAllIntegrationAccess(params);

      //const accessId = accessData?.monster?.[0]?.uiid ? accessData?.monster?.[0]?.uiid : dispatch(setMonsterAccessidStart(params));

      const dispatchData = () => {
        dispatch(setMonsterAccessidStart(params));
        return {
          status: accessData?.monster?.[0]?.integrationData?.status ?? null,
          accessId: accessData?.monster?.[0]?.uiid ?? null,
        };
      };
      //const status = accessData?.monster?.[0]?.integrationData?.status ?? dispatchData()?.status;
      const accessId =
        accessData?.monster?.[0]?.uiid ?? dispatchData()?.accessId;

      const action = {
        accessId: accessId,
        payload: formattedCandidates,
        userId: loginUserUiid,
      };
      try {
        const result = await new Promise((resolve, reject) => {
          dispatch(
            fetchBulkResumesDataStart({
              ...action,
              resolve,
              reject,
            }),
          );
        });
        setMigrateModal(false);
        if (
          result?.newApplicant.length > 0 ||
          result?.existingApplicant.length > 0
        ) {
          const count =
            (result?.newApplicant.length ?? 0) +
            (result?.existingApplicant.length ?? 0);
          showToast(`${count} Profiles Migrated Successfully`, "success", 2000);
        } else if (
          result?.failedResumes.length > 0 &&
          result?.failedResumes[0]?.error ==
            "Credits Expired. Please contact manager."
        ) {
          showToast("Credits Expired. Please contact manager.", "error", 3000);
        } else {
          showToast("Profile migration unsuccessful.", "error", 2000);
        }
        handleMPagination();
      } catch (error) {
        showToast("Profile migration unsuccessful.", "error", 2000);
        console.error(error);
      }
    } catch (err) {
      showToast("Profile migration unsuccessful.", "error", 2000);
      console.error("Error fetching ResumeMining:", err);
    }
  };

  const fetchIntegrations = async () => {
    const integrationsPayload = {
      coll: "Integration",
      fil: JSON.stringify({
        category: { type: "NONE", value: 6 },
        type: { type: "NONE", value: 2 },
        status: { type: "NONE", value: 1 },
      }),
      ret: "uiid name",
    };
    const getIntegrations = await getAllIntegrations(integrationsPayload);

    if (getIntegrations?.success) {
      const integrationIds = getIntegrations?.data?.data?.map(
        (val) => val.uiid,
      );
      const integrationAccessPayload = {
        coll: "IntegrationAccess",
        fil: {
          integrationId: { type: "IN", value: integrationIds },
          userId: { type: "IN", value: loginUserUiid },
          status: { type: "IN", value: 1 },
        },
      };
      const getIntAccess = await getAllIntegrationAccess(
        integrationAccessPayload,
      );
      if (getIntAccess?.success) {
        setHasAiCallAccess(true);
      }
    }
  };

  useEffect(() => {
    fetchIntegrations();
  }, []);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="p-2">
        <FormFieldSet
          type="checkbox"
          noTitle
          multiple={true}
          options={[{ label: "Select Only Migrated Profiles", value: "1" }]}
          onChange={(raw) => {
            setTableRenderKey((prev) => prev + 1);
            const isChecked =
              raw &&
              typeof raw === "object" &&
              ("target" in raw || raw.nativeEvent)
                ? !!raw.target.checked
                : Array.isArray(raw)
                  ? raw.length > 0
                  : typeof raw === "boolean"
                    ? raw
                    : !!raw;
            const final = isChecked ? ["1"] : [];
            setSelectedMigratedProfiles(final);
            handleMigratedProfiles(final);
          }}
          values={selectMigratedProfiles}
        />
      </div>
      <TableAdv
        key={`${tableRenderKey}-${page}-${limit}`}
        columns={columns}
        rows={mappedRows}
        showCheckbox
        onSelectionChange={handleSelectionChange}
        defaultSelectedRows={defaultExistingCandidates}
        toolbarLeft={{
          add: [
            {
              component: (
                <div className="min-w-[200px]">
                  <FormFieldSet
                    type="select"
                    size="sm"
                    noTitle
                    placeholder={"Sort"}
                    value={monsterSort}
                    options={monsterSearchOptions}
                    onChange={(value) => {
                      setMonsterSort(value);
                    }}
                  />
                </div>
              ),
            },
          ],
        }}
        toolbarRight={{
          // search: true,
          fullScreen: true,
          filter: false,
          add: [
            {
              component:
                (showMailMergeForMigrated &&
                  selectMigratedProfiles.includes("1")) ||
                (defaultExistingCandidates.length > 0 &&
                  matchedMigratedCandidates) ? (
                  <div className="flex items-center gap-2">
                    <Button
                      title="Mail Merge"
                      size="sm"
                      variant="outlined"
                      onClick={() => setMailMergeModalOpen(true)}
                    />
                    {hasAiCallAccess && (
                      <Button
                        title="Ai Call"
                        size="sm"
                        variant="outlined"
                        onClick={() => setIsAiCallModalOpen(true)}
                      />
                    )}

                    <Button
                      title="Create List"
                      size="sm"
                      onClick={() => setCreateListModal(true)}
                    />
                  </div>
                ) : (
                  <div className="flex gap-3">
                    <Button
                      title="Migrate profile"
                      size="sm"
                      onClick={() => setMigrateModal(true)}
                    />
                  </div>
                ),
            },
          ],
        }}
        serverPagination={true}
        totalCount={total}
        page={page}
        limit={limit}
        // onPageChange={handlePageChange}
        onLimitChange={handleLimitChangeWithReset}
        onPaginationChange={handlePageChange}
      />
      <Modal isOpen={migrateModal} showCloseButton={false}>
        <div className="py-3">
          <p className="text-center text-sm">
            The System will migrate the{" "}
            {noResumeCandidates.length > 10 ? 10 : noResumeCandidates.length}{" "}
            new profiles automatically. Please Click Yes to proceed
          </p>
          <div className="flex justify-center items-center gap-3 my-3">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => setMigrateModal(false)}
            />
            <Button
              disabled={noResumeCandidates.length == 0 ? true : false}
              title={"Yes"}
              onClick={fetchSubmissions}
            />
          </div>
        </div>
      </Modal>
      <ApplicantsDetailsDrawer
        isOpen={detailsDrawer}
        showResumeButton={showResumeButton}
        onClose={() => setDetailsDrawer(false)}
        applicantId={candidateId ?? noResApplicantId ?? null}
        filteredApplicantData={noResumeCandidate}
        keywords={keywords}
        source={source}
      />
      <MailMergeModal
        mailMergeModalOpen={mailMergeModalOpen}
        filteredMonsterMailMergeData={filtered}
        handleDelete={handleDelete}
        setMailMergeModalOpen={setMailMergeModalOpen}
        selectedData={selected}
      />
      <Backdrop isOpen={loading} zIndex={53}>
        <LogoLoader />
      </Backdrop>
      <CreateListModal
        SetShowCreateListModal={setCreateListModal}
        showCreateListModal={createListModal}
      />
      <AddNoteModal
       key={sendData?.candidateId?.uiid || sendData?.uiid}
        isOpen={noteModal}
        onClose={() => setNotesModal(false)}
        data={sendData}
        source={3}
      />
      <AiCallModel
        isOpen={isAiCallModalOpen}
        onClose={() => setIsAiCallModalOpen(false)}
        // searchQuery={iDBQuery}
        source={3}
        selectedApplicants={filtered}
      />
    </div>
  );
};

export default IntegratedMonster;
